import React from "react";
import "./Footer.css";
import logo from '../assets/logo.webp';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">


        {/* Contact Section */}
        <div className="footer-section">
          <h3>Get in touch</h3>
          <p>34, Wellington Road,<br></br>Eccles<br></br>M30 0NP</p><br></br>
          <p>
            <a href="tel:01615660344" className="phone-link">0161 566 0344</a>
          </p>
          <div className="social-icons">
            <a href="https://www.instagram.com/lasgidirestaurantandlounge/" className="icon"><i className="fab fa-instagram"></i></a>
            <a href="https://wa.me/447368325136" className="icon"><i className="fab fa-whatsapp"></i></a>
            <a href="mailto:restaurantlasgidi@gmail.com" className="icon"><i className="fas fa-envelope"></i></a>
          </div>
        </div>


        {/* Logo Section */}
        <div className="footer-logo">
          <div className="logo-box">
            <img src={logo} alt="logo"></img>
          </div>
          <p className="footer-description">
            At Lasgidi Restaurant, we are dedicated to serving delicious, high-quality meals made with the freshest ingredients.
          </p>
        </div>


        {/* Working Hours Section */}
        <div className="footer-section">
          <h3>Opening Hours</h3>
          <p><strong>Monday:</strong> 13:00 - 22:00</p>
          <p><strong>Tuesday:</strong> 13:00 - 22:00</p>
          <p><strong>Wednesday:</strong> 13:00 - 22:00</p>
          <p><strong>Thursday:</strong> 13:00 - 22:00</p>
          <p><strong>Friday:</strong> 13:00 - 22:00</p>
          <p><strong>Saturday:</strong> 13:00 - 22:00</p>
          <p><strong>Sunday:</strong> 14:00 - 18:30</p>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p><strong>Lasgidi Restaurant</strong> © 2026 All rights reserved</p> <br></br>
        {/* <p className="tracking-powered-by">Powered by <a href="https://naijameals.com" target="_blank" rel="noopener noreferrer">Naijameals.com</a></p> */}
      </div>
    </footer>
  );
};

export default Footer;
